import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useWindowSize from 'hooks/useWindowSize';
import { SCREEN_SIZES } from 'style';
import { ReactComponent as StepOneImage } from 'products/nomad_insurance/assets/img/claims/step-one-copy.svg';
import { ReactComponent as StepThreeImage } from 'products/nomad_insurance/assets/img/claims/step-three-copy.svg';
import { ReactComponent as StepFourImage } from 'products/nomad_insurance/assets/img/claims/step-four-copy.svg';
import {
  ProcessContainer,
  StepImages,
  Divider,
  Description,
  List,
  LearnMore,
  LearnMoreText,
  LearnMoreArrow,
  DescriptionWrapper
} from './styled';
import SubmitClaimButton from './SubmitClaimButton';

const ClaimsProcess = ({ className }) => {
  const [showDescription, setShowDescription] = useState(false);

  const { width } = useWindowSize();
  const isDesktop = width >= SCREEN_SIZES.desktop;

  const { claims } = useSelector((state) => state.nomadInsurance.profile.claims);
  const hasClaims = useMemo(() => claims?.length > 0, [claims]);

  const shouldRenderDescription = isDesktop || !hasClaims || showDescription;

  const { activePaidContracts, contractsIncludingExpired } = useSelector(
    (state) => state.nomadInsurance.contract
  );

  const arrow = showDescription ? '\u25BE' : '\u25B8';

  return (
    <ProcessContainer className={className}>
      {!isDesktop && hasClaims && (
        <LearnMore onClick={() => setShowDescription(!showDescription)}>
          <LearnMoreText>Learn more about how to make a claim</LearnMoreText>
          <LearnMoreArrow>{arrow}</LearnMoreArrow>
        </LearnMore>
      )}
      {shouldRenderDescription && (
        <DescriptionWrapper hasClaims={hasClaims}>
          <StepImages hasClaims={hasClaims}>
            <StepOneImage />
            <Divider hasClaims={hasClaims} />
            <StepThreeImage />
            <Divider hasClaims={hasClaims} />
            <StepFourImage />
          </StepImages>
          <Description>
            Submitting a claim is easy, and only takes about 5 minutes. <br />
            <br />
            {activePaidContracts?.length === 0 && (
              <>
                After you have purchased insurance, come back to this page to file a
                claim.
                <br />
                <br />
              </>
            )}
            We recommend having the following ready if you have them:
            <List>
              <li>
                Your medical report (symptom(s), date of onset, diagnosis, treatment)
              </li>
              <li>Any medical invoices outlining what you paid</li>
              <li>Any relevant receipts</li>
              <li>Your bank account information</li>
            </List>
          </Description>
        </DescriptionWrapper>
      )}

      {contractsIncludingExpired?.length > 0 && (
        <SubmitClaimButton fullWidth={false} color="fountainBlue" />
      )}
    </ProcessContainer>
  );
};

ClaimsProcess.propTypes = {
  className: PropTypes.string
};

export default ClaimsProcess;
